<template>
  <div>
    <sc-text
      v-if="fields && fields.heading"
      :field="fields.heading"
      class="c-nav-dropdown__subheadline"
    />
  </div>
</template>

<script>
import { Text } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-List-Link-Title',
  components: {
    ScText: Text
  },
  props: {
    fields: {
      type: Object
    }
  }
};
</script>
